/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditGroupHasCheckoutLimitApiRequest } from '../../models/hotel-edit-group-has-checkout-limit-api-request';

export interface ApiHotelManageEditGroupCheckoutLimitPost$Params {
      body: HotelEditGroupHasCheckoutLimitApiRequest
}

export function apiHotelManageEditGroupCheckoutLimitPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditGroupCheckoutLimitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditGroupCheckoutLimitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditGroupCheckoutLimitPost.PATH = '/api/hotel/manage/edit/group/checkout-limit';
